export default {
  mounted() {
    const container = document.createElement('div')
    document.body.appendChild(container)
    container.appendChild(this.$el)
    this._teleportContainer = container
  },
  beforeDestroy() {
    if (this._teleportContainer) {
      document.body.removeChild(this._teleportContainer)
    }
  }
}
